import React from 'react';
import { Breadcrumb } from 'antd';
import { useMediaQuery } from 'react-responsive';
import { Helmet } from 'react-helmet';
import './Act.css';
import Footer from '../../Footer';
import { useTranslation } from 'react-i18next'; // Ajout de l'import pour la traduction

const ControlRSC = () => {
   const isMobile = useMediaQuery({ query: '(max-width: 767px)' });
   const { t } = useTranslation(); // Initialisation de la traduction


    
   return (
      <div>
         <Helmet>
            <title>{t('Réception et Suivi de Construction (RSC) - Professional Inspectors')}</title>
            <meta
               name="description"
               content={t("Découvrez nos services de Réception et Suivi de Construction (RSC). Qualification des soudeurs, rédaction du mode opératoire de soudage, approbation du mode opératoire, vérification de poste de soudage, contrôle à la réception des ouvrages mécano-soudés, inspection périodique en service et hors service, contrôle à la réception des ouvrages moulés et assemblés, inspection périodique en service et hors service, contrôle dimensionnel, détection de corrosion, tarage de soupape, contrôle de dégazage, approbation des plans et note de calcul, contrôle qualité quantitatif et qualitatif.")}
            />
            <meta
               name="keywords"
               content={t("Réception et Suivi de Construction, RSC, soudeurs, mode opératoire de soudage, contrôle à la réception, inspection périodique, contrôle dimensionnel, détection de corrosion, tarage de soupape, contrôle de dégazage, approbation des plans, note de calcul, contrôle qualité, Professional Inspectors")}
            />
         </Helmet>

         <div className="wrapper_CTL_z">
            <div className="container_15">
               <Breadcrumb separator=">">
                  <Breadcrumb.Item href="/">{t('Accueil')}</Breadcrumb.Item>
                  <Breadcrumb.Item>{t('Contrôle RSC')}</Breadcrumb.Item>
               </Breadcrumb>
               <div className="row">
                  <div className="pic service_cover">
                     <img src="images/RSC1.jpg" className="img-fluid intro_image" alt={t('Réception et Suivi de Construction (RSC)')} />
                  </div>
                  <div className="col-sm-6 strategic RSC">
                     <h3>{t('Réception et Suivi de Construction (RSC)')}</h3>
                     <p>
                           <li>{t('La qualification des soudeurs.')}</li>
                           <li>{t('La rédaction du mode opératoire de soudage.')}</li>
                           <li>{t('L\'approbation du mode opératoire de soudage.')}</li>
                           <li>{t('La vérification de poste de soudage.')}</li>
                           <li>{t('Le contrôle à la réception des ouvrages mécano-soudés (tanks,...).')}</li>
                           <li>{t('L\'inspection périodique en service et hors service des ouvrages mécano-soudés (tanks,...).')}</li>
                           <li>{t('Le contrôle à la réception des ouvrages moulés et assemblés (vannes...).')}</li>
                           <li>{t('L\'inspection périodique en service et hors service des ouvrages moulés et assemblés (vannes...).')}</li>
                           <li>{t('Le contrôle dimensionnel.')}</li>
                           <li>{t('La détection de corrosion.')}</li>
                           <li>{t('Le tarage de soupape.')}</li>
                           <li>{t('Le contrôle de dégazage.')}</li>
                           <li>{t('L\'approbation des plans et la note de calcul.')}</li>
                           <li>{t('Le contrôle qualité (quantitatif et qualitatif).')}</li>
                     </p>
                  </div>
               </div>
            </div>
            <section className="solutions-area" id="services">
               <div className="container">
                  <div className="section-title">
                     <span className="sub-title">{t('Autres Activités')}</span>
                     <h2>{t('Domaine d\'Application')} :</h2>
                     <p>{t('La société « PROFESSIONAL INSPECTORS » assure le contrôle et l’inspection dans les domaines suivants :')}</p>
                  </div>
               </div>
               <main className="page-content-C">
                  <div className="card CND">
                     <div className="content">
                        <h2 className="title">{t('Contrôle Non Destructif (CND)')}</h2>
                        <p className="copy"></p>
                        <a href="/controlCND">
                           <button className="btn">{t('Détails')}</button>
                        </a>
                     </div>
                  </div>
                  <div className="card CRS">
                     <div className="content">
                        <h2 className="title">{t('Contrôle Réglementaire de Sécurité (CRS)')}</h2>
                        <p className="copy"></p>
                        <a href="/controlCRS">
                           <button className="btn">{t('Détails')}</button>
                        </a>
                     </div>
                  </div>
               </main>
            </section>
            <Footer />
         </div>
      </div>
   );
};

export default ControlRSC;
